import React from 'react';
import { Box } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';
import HeaderTwo from '../../component/header/HeaderTwo';
import Footer from '../../component/footer/Footer';
import Breadcrumb from '../../component/common/Breadcrumb';
import PackagePlansCard from '../../element/card/fundi/PackagePlansCard';


const PackagePlansPage = () => {
  const { isSM, isMd, isMD,isLg } = useThemeContext()
  return (
    <>
      <Box
        sx={{
          width: isSM ? '100%' : isMd ? '100%' : isLg ? '100%' : '100%',
          height:'100%',
          padding: '0',
          boxSizing: 'border-box',
        }}
      >
        <HeaderTwo />
       
        <Breadcrumb parent="Home" title="Job" title1="Explore Job" title2="Job Details" />
        <Box
          sx={{
            width: isSM ? '100%' :isMD ? '100%' : isMd ? '1007px' : isLg ? '1207px' : '1207px',
            height:'100%',
            padding:  isSM ? '1rem' :isMD ? '2rem' : isMd ? '10px' :0,
            margin:'0 auto',
            boxSizing: 'border-box',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            gap:2
          }}
        >
       <PackagePlansCard/>
       <PackagePlansCard/>
       <PackagePlansCard/> 
        </Box>

        <Footer />
      </Box>


    </>
  )
}





export default PackagePlansPage;